"use client"

import {
    type LucideIcon,
} from "lucide-react"

import {
    SidebarGroup,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    useSidebar,
} from "@/components/ui/sidebar"
import { usePolicy } from "@/context/PolicyContext"

import Link from 'next/link'
import { useTranslation } from "react-i18next"
import { useAuth } from "@/context/AuthContext"

export function NavAdmin({
    items,
}: {
    items: {
        name: string
        url: string
        icon: LucideIcon,
        isActive?: boolean
        permission: string
    }[]
}) {
    const { user } = useAuth()
    const { t } = useTranslation()
    const { hasPermission } = usePolicy()
    const { setOpenMobile } = useSidebar()

    return (
        <SidebarGroup>
            <SidebarGroupLabel>
                Admin
            </SidebarGroupLabel>
            <SidebarMenu>
                {items.map((item) => (
                    (hasPermission(item.permission) || user?.is_admin) &&
                    <SidebarMenuItem key={item.name}>
                        <SidebarMenuButton isActive={item.isActive} tooltip={item.name} asChild>
                            <Link href={item.url} onClick={() => { setOpenMobile(false) }}>
                                {item.icon && <item.icon strokeWidth={item.isActive ? 3 : 2} />}
                                <span className={item.isActive ? "font-bold" : "font-normal"}>{t(item.name)}</span>
                            </Link>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                ))}
            </SidebarMenu>
        </SidebarGroup>
    )
}
